import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import styles from './Navbar.module.css';

export default function Navbar() {
  const { currentUser, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  const initial = currentUser?.email?.charAt(0).toUpperCase() || 'U';

  return (
    <header className={styles.navbar}>
      <div className={styles.searchBox}>
        <span className={styles.searchIcon}>⌕</span>
        <input placeholder="بحث سريع..." />
      </div>

      <div className={styles.actions}>
        <button className={styles.iconBtn} onClick={toggleTheme} title="تبديل الوضع الليلي">
          {theme === 'light' ? '🌙' : '☀️'}
        </button>

        <div className={styles.userMenu}>
          <button className={styles.userBtn} onClick={() => setMenuOpen((v) => !v)}>
            <span className={styles.avatar}>{initial}</span>
            <span className={styles.userEmail}>{currentUser?.email}</span>
          </button>

          {menuOpen && (
            <div className={styles.dropdown}>
              <button onClick={logout} className={styles.logoutBtn}>
                تسجيل الخروج
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
